module.exports = __webpack_public_path__ + "static/media/LoginBlock.a0858029.png";